import React from 'react';
import { Badge } from './Badge';

const appointmentStatus = {
  1: { label: 'Attesa conferma', variant: 'warning' },
  2: { label: 'Confermato', variant: 'info' },
  3: { label: 'Completato', variant: 'success' },
  4: { label: 'Annullato', variant: 'danger' }
};

const uploadStatus = {
  queued: { label: 'In coda', variant: 'default' },
  uploading: { label: 'Caricamento', variant: 'primary' },
  completed: { label: 'Completato', variant: 'success' },
  error: { label: 'Errore', variant: 'danger' }
};

export const AppointmentStatusBadge = ({ idStatus, label }) => {
  const status = appointmentStatus[idStatus] || { label: label || 'Sconosciuto', variant: 'default' };
  return <Badge variant={status.variant}>{label || status.label}</Badge>;
};

export const UploadStatusBadge = ({ status }) => {
  const item = uploadStatus[status] || { label: status || 'Sconosciuto', variant: 'default' };
  return <Badge variant={item.variant}>{item.label}</Badge>;
};
